import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { DataService } from '../../services/data/data.service';
import { UserService } from '../../services/user/user.service';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { CalendarService } from '../../services/calendar/calendar.service';
import { HelpService } from '../../services/help/help.service';

@Component({
	selector: 'pcm-contractor-detail',
	templateUrl: './contractor-detail.component.html',
	styleUrls: ['./contractor-detail.component.scss']
})
export class ContractorDetailComponent implements OnChanges {
	// showing the create form ONLY shows the create form
	@Input() showCreateForm = false;
	@Input() calendarAccessErrorMessage;
	@Input() allowReject;
	@Input() contractorDetailsData;
	
	@Output() newContractorFormSubmit: EventEmitter<any> = new EventEmitter();
	@Output() contractorEditFormSubmit: EventEmitter<any> = new EventEmitter();
	@Output() reject: EventEmitter<any> = new EventEmitter();
	@Output() approve: EventEmitter<any> = new EventEmitter();

	@ViewChild('uiTabs') uiTabs;

	newContractorTitle = 'New Contractor Record';
	editContractorTitle = 'Contractor Edits';
	contractorDetailsTitle = 'Details';
	calendarNotSetUpMessage = 'Invoice calendars have not been set up yet and are required for contractor record creation. Please contact you admininstrator.';
	tabTooltip = this.helpService.contractor_tooltips.details;
	// this will be updated with the validity state of the invoice calendar field
	invoiceCalendarFieldValidity = { valid: true, touched: false };

	constructor(public contractorService: ContractorService,
		public dataService: DataService,
		public configService: ConfigService,
		public invoiceService: InvoiceService,
		public userService: UserService,
		private calendarService: CalendarService,
		private helpService: HelpService
		) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['contractorDetailsData']) {
			this.handleContractorFormChange();
		}
	}

	isTabVisible(name: string): boolean {
		const activeTab = this.contractorService.getActiveTab(this.contractorService.tabsData.tabs);
		if (activeTab.prop === 'myapprovals') {
			// if the active tab is My Approvals, then also check if either 'done' or 'undone' is defined
			return (name === activeTab.prop && Boolean(activeTab.undone || activeTab.done));
		} else {
			return name === activeTab.prop;
		}
	}

	handleNewContractorFormSubmit(event) {
		this.newContractorFormSubmit.emit(event);
	}

	handleContractorFormChange() {
		if (this.uiTabs) {
			this.uiTabs.checkTabs(this.contractorService.tabsData.tabs);
		}
	}

	handleContractorEditFormSubmit(event) {
		this.contractorEditFormSubmit.emit(event);
	}

	handleApprove() {
		this.approve.emit();
	}

	handleReject() {
		this.reject.emit();
	}

	getInvoiceCalendarName() {
		return this.calendarService.getCalendarName(this.dataService.poDetails[this.configService.calendarIdProp]);
	}

	/**
	 * passed into the data-form component to configure the form to update the ilcSerialNum field
	 * each time the buyerContractorId field is updated
	 */
	configureReactiveField = (form) => {
		const buyerContractorIdField = form.get(this.configService.buyerContractorId);
		if (buyerContractorIdField) {
			buyerContractorIdField.valueChanges.subscribe(value => {
				if (value && value.length > 0) {
					const ilcNumFieldValue = form.get(this.configService.ilcSerialNumProp)?.value;
					if (!ilcNumFieldValue || !ilcNumFieldValue.toLowerCase().startsWith('z')) {
						form.get(this.configService.ilcSerialNumProp).setValue(value);
					}
				}
			});
		}
	}

	handleInvoiceCalendarValueChange() {
		this.invoiceCalendarFieldValidity = {
			valid: this.userService.canAccessCal(),
			touched: true
		};
	}
}
